import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Filter, Clock, BookOpen, Star } from 'lucide-react';

/**
 * Filtering and sorting options panel with functional controls
 */
const FilterOptions = React.memo(({ 
  isVisible, 
  sortBy, 
  onSortChange,
  favorites,
  onToggleFavoritesOnly,
  showFavoritesOnly
}) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        className="mt-3 p-3 bg-slate-800 rounded-md border border-slate-700 shadow-lg overflow-hidden"
      >
        <div className="flex items-center gap-2 mb-2.5">
          <div className="p-1 bg-emerald-500/20 rounded">
            <Filter className="w-3.5 h-3.5 text-emerald-300" />
          </div>
          <span className="text-sm text-slate-200 font-medium">Sort and filter</span>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
          <button 
            onClick={() => onSortChange('newest')}
            className={`px-3 py-2 rounded flex items-center justify-center gap-1.5 transition-colors text-sm ${
              sortBy === 'newest' 
                ? 'bg-emerald-600 text-white' 
                : 'bg-slate-700 text-slate-200 hover:bg-slate-600'
            }`}
          >
            <Clock className="w-3.5 h-3.5" />
            <span>Newest</span>
          </button>
          <button 
            onClick={() => onSortChange('oldest')}
            className={`px-3 py-2 rounded flex items-center justify-center gap-1.5 transition-colors text-sm ${
              sortBy === 'oldest' 
                ? 'bg-emerald-600 text-white' 
                : 'bg-slate-700 text-slate-200 hover:bg-slate-600'
            }`}
          >
            <Clock className="w-3.5 h-3.5" />
            <span>Oldest</span>
          </button>
          <button 
            onClick={() => onSortChange('alphabetical')}
            className={`px-3 py-2 rounded flex items-center justify-center gap-1.5 transition-colors text-sm ${
              sortBy === 'alphabetical' 
                ? 'bg-emerald-600 text-white' 
                : 'bg-slate-700 text-slate-200 hover:bg-slate-600'
            }`}
          >
            <BookOpen className="w-3.5 h-3.5" />
            <span>A-Z</span>
          </button>
          <button 
            onClick={onToggleFavoritesOnly}
            className={`px-3 py-2 rounded flex items-center justify-center gap-1.5 transition-colors text-sm ${
              showFavoritesOnly
                ? 'bg-emerald-600 text-white' 
                : 'bg-slate-700 text-slate-200 hover:bg-slate-600'
            }`}
            disabled={favorites.length === 0}
            title={favorites.length === 0 ? "No favorites available" : ""}
          >
            <Star className="w-3.5 h-3.5" 
              style={{ 
                color: showFavoritesOnly ? 'white' : '#10b981',
                opacity: favorites.length === 0 ? 0.5 : 1 
              }} 
            />
            <span style={{ opacity: favorites.length === 0 ? 0.5 : 1 }}>Favorites</span>
          </button>
        </div>
        
        {favorites.length === 0 && showFavoritesOnly && (
          <div className="mt-2 text-xs text-slate-400 text-center">
            No favorites yet. Star a conversation to add it to your favorites.
          </div>
        )}
      </motion.div>
    )}
  </AnimatePresence>
));

export default FilterOptions;